<template>
    <input type="text" :value="localValue" @input="onInput" @focus="onFocus" @blur="onBlur" />
</template>

<script>
export default {
    name: "PercentageInput",
    props: {
        modelValue: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            localValue: "",    // texte visible dans le champ
            isFocused: false,  // pour savoir si l'utilisateur édite
        };
    },
    mounted() {
        // On initialise avec le format % dès le début
        this.localValue = this.formatWithPercentage(this.modelValue);
    },
    watch: {
        modelValue(newVal) {
            // Si modelValue change et que l'utilisateur n'édite pas, on reformate
            if (!this.isFocused) {
                this.localValue = this.formatWithPercentage(newVal);
            }
        },
    },
    methods: {
        formatRaw(value) {
            if (value == null || isNaN(value)) return "";
            return value.toString().replace(".", ",");
        },
        formatWithPercentage(value) {
            if (value == null || isNaN(value)) return "";
            return `${value.toFixed(2)}%`;
        },
        onFocus() {
            this.isFocused = true;
            this.localValue = this.formatRaw(this.modelValue);
        },
        onBlur() {
            this.isFocused = false;
            const raw = this.localValue.replace("%", "").trim().replace(",", ".");
            const parsed = parseFloat(raw);

            if (!isNaN(parsed)) {
                this.$emit("update:modelValue", parsed);
                this.localValue = this.formatWithPercentage(parsed);
            } else {
                this.$emit("update:modelValue", null);
                this.localValue = "";
            }
        },
        onInput(event) {
            let val = event.target.value;

            // Ne pas laisser l’utilisateur taper plus de 100
            const raw = val.replace("%", "").trim().replace(",", ".");
            const parsed = parseFloat(raw);

            if (!isNaN(parsed) && parsed > 100) {
                val = "100";
            }

            this.localValue = val;
        },
    },
};
</script>

<style scoped>
input {
    text-align: right;
}
</style>
